import React from 'react';
import styles from './Toggle.module.css';

/**
 * Toggle/Switch Component
 * Accessible checkbox-based toggle
 */
const Toggle = ({
    checked = false,
    onChange,
    disabled = false,
    label,
    id,
    className = '',
    ...props
}) => {
    const toggleId = id || `toggle-${Math.random().toString(36).substr(2, 9)}`;

    return (
        <div className={`${styles.wrapper} ${className}`}>
            <input
                type="checkbox"
                id={toggleId}
                className={styles.input}
                checked={checked}
                onChange={onChange}
                disabled={disabled}
                {...props}
            />
            <label htmlFor={toggleId} className={styles.toggle}>
                <span className={styles.track}>
                    <span className={styles.thumb} />
                </span>
            </label>
            {label && (
                <label htmlFor={toggleId} className={styles.label}>
                    {label}
                </label>
            )}
        </div>
    );
};

export default Toggle;
